import { render, staticRenderFns } from "./purchase_return_goods.vue?vue&type=template&id=5eb8474e&scoped=true&"
import script from "./purchase_return_goods.vue?vue&type=script&lang=js&"
export * from "./purchase_return_goods.vue?vue&type=script&lang=js&"
import style0 from "./purchase_return_goods.vue?vue&type=style&index=0&id=5eb8474e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb8474e",
  null
  
)

export default component.exports